import React, { Component } from 'react';
import { DebounceInput } from 'react-debounce-input';
import { ChatStrong } from '../../../../../assets/images';
import Icon from '../../../core/Icon';
import Buttons from '../../../core/Buttons';
import { StyledChat, StyledAvatarPerson, StyledLabelButton } from './style';
import {
  getContactsByName,
  getMemberTeams,
  getInfoTeam
} from '../../../../utils/officeIntegration';

import Loading from '../../../core/Loading';

const BASE = 'https://teams.microsoft.com/_#/conversations/8:orgid:';
const PARAMS = '?ctx=chat';

class WidgetChatFind extends Component {
  constructor(props) {
    super(props);
    this.state = { contactList: undefined, showAutocomplete: false, teams: [] };
  }

  componentDidMount() {
    const { teams } = this.state;
    const infoTema = teams;
    getMemberTeams()
      .then(data => {
        data.value.map(team =>
          getInfoTeam(team.id)
            .then(info => {
              infoTema.push(info);
              this.setState({ teams: infoTema });
            })
            .catch(e => console.warn('>>> WidgetChat error', e))
        );
      })
      .catch(e => console.warn('>>> WidgetChat error', e));
  }

  onChangeHandler = evt => {
    const { value } = evt.target;
    if (value) {
      getContactsByName(value).then(contactList => {
        const { value } = contactList;
        return this.setState({ contactList: value, showAutocomplete: true });
      });
    } else {
      this.setState({ contactList: undefined });
    }
  };

  render() {
    const { className } = this.props;
    const { contactList, showAutocomplete, teams } = this.state;
    return (
      <StyledChat className={className}>
        <h2 className="title">
          <Icon svg={ChatStrong} className="icon-title" />
          Iniciar conversación
        </h2>
        <div>
          <p className="chat-sub-title">¿Con quién quieres chatear?</p>
          <div className="chat-wrapper-contact">
            <DebounceInput
              debounceTimeout={500}
              type="text"
              name="fname"
              onChange={this.onChangeHandler}
              className="chat-autocomplete"
              placeholder="Nombre..."
            />
            {showAutocomplete && (
              <ul className="chat-contact-list">
                {contactList &&
                  contactList.map(element => {
                    const { id, displayName } = element;
                    const letters = displayName.split(' ');
                    return (
                      <li
                        className="chat-contact"
                        key={Math.round(Math.random() * 999999)}
                      >
                        <a
                          href={`${BASE}${id}${PARAMS}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="chat-contact-link"
                        >
                          <StyledAvatarPerson
                            name={letters[0]}
                            lastname={letters[1]}
                          />
                        </a>
                        <a
                          href={`${BASE}${id}${PARAMS}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="chat-contact-link chat-contact-link--text "
                        >
                          {displayName}
                        </a>
                      </li>
                    );
                  })}
              </ul>
            )}
          </div>
        </div>
        <StyledLabelButton>
          <span>Equipos de trabajo</span>
          <Buttons type="button" secondary>
            <a
              href="https://teams.microsoft.com/_#/discover"
              target="_blank"
              rel="noopener noreferrer"
            >
              Crear equipo
            </a>
          </Buttons>
        </StyledLabelButton>
        <div className="chat-lister">
          {teams ? (
            <ul className="chat-list">
              {teams.map(team => (
                <li className="chat-item" key={team.id}>
                  <a
                    href={team.webUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="chat-msj"
                  >
                    Ir
                  </a>
                  <div className="chat-animation">
                    <a
                      href={team.webUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="chat-msj-animation"
                    >
                      Ir
                    </a>
                  </div>

                  <StyledAvatarPerson
                    name={`${team.displayName[0]}`}
                    lastname={`${team.displayName[1]}`}
                  />

                  <div className="chat-wrapper-msj">
                    <p className="chat-name">{team.displayName}</p>

                    <p className="chat-msj-txt">
                      <span>{team.description && team.description}</span>
                    </p>
                  </div>
                </li>
              ))}
            </ul>
          ) : (
            <Loading txt="Cargando equipos..." size="l" color="light" />
          )}
        </div>
      </StyledChat>
    );
  }
}

export default WidgetChatFind;
